import HelpPage from './HelpPage';

export default HelpPage;


// WEBPACK FOOTER //
// ./src/components/HelpPage/index.jsx